import React from 'react';
import { render } from 'react-dom';

import HeroBanner from '../react/HeroBanner';

export default class HeroBannerRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { title, subtitle, description, image, videoUrl, fallbackImage } = this.context.dataset;
    if (!image && !videoUrl && !fallbackImage) throw Error('Missing a required dataset');
    const jsonImage = image ? JSON.parse(image) : undefined;
    const jsonFallbackImage = fallbackImage ? JSON.parse(fallbackImage) : undefined;

    render(
      <HeroBanner
        title={title}
        subTitle={subtitle}
        description={description}
        image={jsonImage}
        videoUrl={videoUrl}
        fallbackImage={jsonFallbackImage}
      />,
      this.context
    );
  }
}
